package org.ksdfv.thelema.img

import org.ksdfv.thelema.data.DATA
import org.ksdfv.thelema.data.IByteData
import org.ksdfv.thelema.fs.FS
import org.ksdfv.thelema.fs.FileLocation
import org.ksdfv.thelema.fs.IFile

/** @author zeganstyl */
interface IImg {
    fun image(): IImageData =
        ImageData(0, 0, DATA.nullBuffer)

    fun load(
        url: String,
        out: IImageData = image(),
        sourceLocation: Int = FileLocation.Internal,
        response: (status: Int, img: IImageData) -> Unit = { _, _->}
    ): IImageData =
        load(FS.file(url, sourceLocation), out, response)

    fun load(file: IFile, out: IImageData = image(), response: (status: Int, img: IImageData) -> Unit = { _, _->}): IImageData {
        out.name = file.path
        file.readBytes { status, obj -> load(obj, out) { _,_ -> response(status, out) } }
        return out
    }

    /** @param byteArray Raw bytes with file header */
    fun load(byteArray: ByteArray, out: IImageData = image(), response: (status: Int, img: IImageData) -> Unit = { _, _->}): IImageData {
        val bytes = DATA.bytes(byteArray.size)
        bytes.put(byteArray)
        bytes.position = 0
        load(bytes, out, response)
        return out
    }

    /** @param data Raw bytes with file header */
    fun load(data: IByteData, out: IImageData = image(), response: (status: Int, img: IImageData) -> Unit = { _, _->}): IImageData
}